import React from 'react';

import { Wrapper } from './wrapper';

interface Props {
  children: React.ReactNode | string;
  noMargin?: boolean;
  disabled?: boolean;
  iconPrefix?: boolean;
}

const InputHelp = ({ children, noMargin, disabled, iconPrefix }: Props) => (
  <Wrapper $noMargin={noMargin} $disabled={disabled} $iconPrefix={iconPrefix}>
    {children}
  </Wrapper>
);

export default InputHelp;
